export default import.meta.ROLLUP_FILE_URL_mgMzFw0uJ1xNpAur_hRXpQ